<!--ef476f-->
<!--ffd166-->
<!--06d6a0-->
<!--118ab2-->
<!--073b4c-->

<template>
    <div style="float: left;">
        <v-card dark width="200" class="mr-3 mb-3" color="red" href="/orders/shippedHistory?filter=seur">
            <v-list-item>
                <v-list-item-title class="headline">DPD</v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <div class="overline" style="height: 30px; line-height: 15px;">REEMBOLSOS PENDENTES</div>
                </v-list-item-content>
                <v-list-item-avatar tile size="40">
                    <span class="headline">{{ value }}</span>
                </v-list-item-avatar>
            </v-list-item>
        </v-card>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                loading: true,
                value: 0
            }
        },
        created() {
            this.initialize()
        },
        methods: {
            initialize() {
                this.loading = true;
                let request = {url: '/api/staff/dashboard/widget/pendingRefunds/seur'};
                ApiWS.dispatch('makeGet', request)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData.status === 'OK') {
                            this.value = responseData.value;
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
        }
    }
</script>
